/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

function GestionUsuarios() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="primary"
                borderRadius="lg"
                coloredShadow="primary"
              >
                <MDTypography variant="h6" color="white">
                  Gestión de Usuarios
                </MDTypography>
              </MDBox>
              <MDBox pt={3} pb={3} px={3}>
                <MDTypography variant="h5" gutterBottom>
                  Bienvenido a Gestión de Usuarios
                </MDTypography>
                <MDTypography variant="body1" color="text">
                  Desde aquí puedes gestionar usuarios y empresas del sistema con funcionalidades completas:
                </MDTypography>
                <MDBox mt={3}>
                  <MDTypography variant="h6" gutterBottom>
                    Módulos disponibles:
                  </MDTypography>
                  <MDBox component="ul" m={0} pl={4}>
                    <MDBox component="li" color="text" fontSize="0.875rem" lineHeight={1.625}>
                      <strong>Empresas:</strong> Gestiona empresas con opciones para crear, editar, ver y eliminar
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default GestionUsuarios; 